export const RESET_STATE = 'RESET-STATE'
export const SET_GOALS = 'SET-GOALS'
export const IS_LOADING = 'IS-LOADING'
export const SET_GOALS_HASH = 'SET_GOALS_HASH'
